module.exports = __webpack_public_path__ + "img/adhka-yx1zn.011.b612e12a.jpeg";